import $ from '@vaersaagod/tools/Dom';
import 'gsap/TextPlugin';
import TimelineLite from 'gsap/TimelineLite';

export default (el, props) => {
    const output = $(el).find('[data-output]').get(0);

    let timeline = null;

    const textShift = () => {
        timeline.eventCallback('onReverseComplete', null);
        props.push(props.shift());
        textIn();
    };

    const textOut = () => {
        timeline.eventCallback('onComplete', null);
        timeline.eventCallback('onReverseComplete', textShift);
        timeline.timeScale(2).reverse();
    };

    const textIn = () => {
        timeline = new TimelineLite();
        timeline.eventCallback('onComplete', textOut);
        timeline.add(TweenLite.to(output, 6, { text: props[0], ease: Quad.easeInOut }));
    };

    const init = () => {
        textIn();
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/TextAnimation.js